/**
 * What this game has written on its cards.
 *
 * A context rather than a prop, for the reason `useSkin` is one: a card is
 * drawn from four places - a hand, a table zone, a card in flight, the one
 * held up after a draw - and threading the same map through all four would be
 * four chances to forget it somewhere and have a two stop being a two halfway
 * across the screen.
 *
 * Empty for every game that has not written on its deck, which is all of them
 * but Super Crazy Eights. An empty map costs a lookup that misses.
 */

import { createContext, useContext } from 'react';

export type CardMarks = { readonly [rank: string]: string };

const NONE: CardMarks = {};

const MarksContext = createContext<CardMarks>(NONE);

export function useCardMarks(): CardMarks {
  return useContext(MarksContext);
}

export function MarksProvider({
  marks,
  children,
}: {
  marks: CardMarks | undefined;
  children: React.ReactNode;
}) {
  return <MarksContext.Provider value={marks ?? NONE}>{children}</MarksContext.Provider>;
}
